import React, { useEffect, useState } from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import TrendingItem from './TrendingItem';
import { jarallax, jarallaxElement } from "jarallax";
import 'jarallax/dist/jarallax.css';
import 'jarallax/dist/jarallax.min.js';
import 'jarallax/dist/jarallax-element.min.js';
import axiosInstance from '../axiosConfig';
import '../styles/loader.css';
import Loader from "../components/Loader";



const TrendingStyles = () => {
    const [trendingstyles, setTrendingstyle] = useState([]);
    const [heading, setHeading] = useState("");
    const [options, setOptions] = useState({});
    const [loading, setLoading] = useState(true);
    

    jarallaxElement();

    useEffect(() => {
        jarallax(document.querySelectorAll('.jarallax'));
    }, [trendingstyles]);

    useEffect(() => {
        const fetchTrendingStyle = async () => {
            try {
                const response = await axiosInstance.get('/slider/tranding-styles');
                if (response.data.success) {
                    setHeading(response.data.slider.heading || "Trending Styles");
                    setTrendingstyle(response.data.slider.link_slider_content || []);
                }
            } catch (error) {
                console.error("Error fetching trending styles:", error);
            }finally {
                setLoading(false);
            }
        };

        fetchTrendingStyle();
    }, []);

    useEffect(() => {
        const dynamicOptions = {
            center: true,
            loop: true,
            margin: 0,
            nav: true,
            navText: [
                "<i class='fa fa-angle-left'></i>",
                "<i class='fa fa-angle-right'></i>"
            ],
            dots: false,
            responsive: {
                1000: {
                    items: trendingstyles.length > 5 ? 4 : trendingstyles.length 
                },
                600: {
                    items: trendingstyles.length > 3 ? 2 : trendingstyles.length 
                },
                0: {
                    items: 2
                }
            }
        };

        setOptions(dynamicOptions);
    }, [trendingstyles]);


    if (loading) {
        return <Loader />;
    }

    const TrendingBox = trendingstyles.map((item, index) => ({
        trendingname: item.title,
        trendingnumber: index + 1,
        img: item.image
    }));

    return (
        <section id="section-trending" className="trending pt80">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2 text-center">
                        <h2 className="wow fadeIn">{heading}</h2>
                        <div className="de-separator"></div>
                        <div className="spacer-single"></div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12 jarallax" data-jarallax-element="-20">
                        <div className="d-carousel wow fadeInRight">
                            {options.responsive ? (
                                <OwlCarousel className="owl-carousel owl-theme no-hide owl-center" {...options}>
                                    {
                                        TrendingBox.map((TrendingDetails) => (
                                            <TrendingItem TrendingDetails={TrendingDetails} key={'' + TrendingDetails.trendingnumber} />
                                        ))
                                    }
                                </OwlCarousel>
                            ) : (
                                <div>Loading...</div> 
                            )}
                        </div>
                        <div className="spacer-double"></div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TrendingStyles;
